import styled from "@emotion/styled";
import { baseStyles } from "./base.styles";
import { Colors } from "theme/colors";
import { css } from "@emotion/react";
import Icon from "components/icon";
import { shouldForwardProp } from "theme/utils";

export const StyledInputContainer = styled.div`
  position: relative;

  .react-datepicker__view-calendar-icon input {
    padding: calc(0.625rem - 0.118rem) calc(1.25rem - 0.118rem);
    cursor: default;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__calendar-icon {
    right: 0.5rem;
    top: 0.29rem;
    cursor: default;
  }

  .react-datepicker__close-icon {
    right: 2.18rem;
    top: 0.06rem;

    &::after {
      background-color: ${Colors.BLACK};
    }
  }
`;

interface InputProps {
  $hover: boolean;
}

export const StyledInput = styled.input<InputProps>`
  border-radius: 0.625rem;
  width: 100%;
  outline: none;
  font-size: 0.9375rem;
  height: 2.47rem;

  ${baseStyles};
  cursor: pointer !important;
  &:disabled {
    cursor: default !important;
  }

  ${(props) =>
    props.$hover &&
    css`
      background-color: ${Colors.LIGHT_GRAY};
    `}

  // box-shadow
  box-shadow: 0 0.294rem 0.59rem 0 rgba(0, 0, 0, 0.2) inset;
`;

export const StyledIcon = styled(Icon, { shouldForwardProp })`
  pointer-events: none;
`;
